// src/contexts/TrendingContext.jsx

import React, { createContext, useContext, useEffect, useState } from 'react';
import { BASE_URL } from '../config/config';

const TrendingContext = createContext();

export const TrendingProvider = ({ children }) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchTrending = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${BASE_URL}/products`);
      const json = await res.json();
      if (res.ok && json.status === 200) {
        const trendingProducts = json.data
          .filter((item) => item.product_category_name === 'Trending')
          .map((item) => ({
            id: Number(item.id),
            name: item.name,
            category:item.category_name,
            description: item.description,
            price: Number(String(item.amount).replace(/,/g, "")),        // ORIGINAL
          offer_price: item.offer_price
            ? Number(String(item.offer_price).replace(/,/g, ""))
            : 0,   
            image: item.images
            ? `${item.images.split(',')[0]}`
            : 'https://via.placeholder.com/300x400?text=No+Image',
            createdAt: item.create_audit_time,
            raw: item, // optional: full data
          }));

        setProducts(trendingProducts);
      } else {
        throw new Error(json.message || 'Failed to fetch products');
      }
    } catch (err) {
      console.error('Trending fetch error:', err);
      setError(err.message || 'Error fetching products');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTrending();
  }, []);

  return (
    <TrendingContext.Provider value={{ products, loading, error, refetch: fetchTrending }}>
      {children}
    </TrendingContext.Provider>
  );
};

export const useTrending = () => useContext(TrendingContext);
